<app-add-poi  [viewTitle]="title" [parentIdValue]="parentCategoryId" [isParentCategory]="isParentCategory"></app-add-poi>